import React from 'react';
import { Link } from 'react-router-dom';

// Transparent pixel fallback; replaced if VITE_LOGO_URL provided.
const fallbackPixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=';
const logoSrc: string = (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_LOGO_URL) || fallbackPixel;

export type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'monoInverted';
  clickable?: boolean;
  onClick?: React.MouseEventHandler<HTMLImageElement | HTMLAnchorElement>;
  className?: string;
  style?: React.CSSProperties;
};

const heights: Record<NonNullable<LogoProps['size']>, number> = {
  sm: 24,
  md: 36,
  lg: 48,
};

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  variant = 'default',
  clickable = false,
  onClick,
  className,
  style,
}) => {
  const height = heights[size];
  const img = (
    <img
  src={logoSrc}
      alt="Suuq"
      role="img"
      height={height}
      style={{
        height,
        width: 'auto',
        display: 'block',
        userSelect: 'none',
        ...(variant === 'monoInverted' ? { filter: 'brightness(0) invert(1)' } : {}),
        ...style,
      }}
      loading={clickable ? undefined : 'lazy'}
      decoding="async"
      draggable={false}
      onClick={onClick}
      className={className}
    />
  );
  if (clickable) {
    return (
      <Link to="/" onClick={onClick} style={{ display: 'inline-flex', alignItems: 'center', outline: 'none' }}>
        {img}
      </Link>
    );
  }
  return img;
};

export default Logo;
